import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ManageSearch } from "../../../../../../assets/icons";
import { ThemeColors } from "../../../../../../theme/themeValues";

interface CustomNoRowsOverlayProps {
	message?: string;
}

const CustomNoRowsOverlay: React.FC<CustomNoRowsOverlayProps> = ({ message }) => {
	const { t } = useTranslation("result.transport");

	return (
		<Box
			sx={{ cursor: "default" }}
			width="100%"
			height="100%"
			display="flex"
			justifyContent="center"
			alignItems="center"
		>
			<Stack textAlign="center">
				<Box>
					<ManageSearch sx={{ fontSize: "2.5rem", color: ThemeColors.LightInfo }} />
				</Box>
				<Typography variant="body2" color={ThemeColors.LightInfo}>
					{message || t("no results message")}
				</Typography>
			</Stack>
		</Box>
	);
};

export default CustomNoRowsOverlay;
